export const CompanyFormFields = {
  LEGAL_NAME: 'legalName',
  REGISTRATION_CODE: 'registrationCode',
  LEGAL_ADDRESS: 'legalAddress',
  ZIP: 'zip',
  CITY: 'city',
  COUNTRY: 'country',
} as const

export const PersonFormFields = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  INTL_CODE: 'intlCode',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
} as const

// Internal validation message keys used by react-hook-form to distinguish error types.
// Not displayed to users — compared against to select the correct translated message.
export const VALIDATION_MESSAGES = {
  INVALID_FORMAT: 'Invalid format',
  REQUIRED: 'Required field',
} as const
